import { useEffect, useState } from "react";

export default function useTimer({ timeout, onEnd }) {
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    return () => clearTimeout(timer);
  }, [timer]);

  function startTimer() {
    const job = setTimeout(onEnd, timeout);
    setTimer(job);
  }

  function clearTimer() {
    setTimer(null);
  }

  function restartTimer() {
    startTimer();
  }

  return { startTimer, clearTimer, restartTimer };
}
